const i = {
  yAxisId: "hr",
  domain: [0, 160],
  label: "BPM"
}, s = {
  yAxisId: "rr",
  domain: [0, 40],
  label: "BRPM"
};
export {
  i as leftAxis,
  s as rightAxis
};
